window.isDesktop = window.innerWidth > 1100;
var hasGSAP = typeof gsap != 'undefined' && typeof gsap !== typeof undefined;
var hasScrollTrigger = typeof ScrollTrigger != 'undefined' && typeof ScrollTrigger !== typeof undefined;
console.log('hasGSAP', hasGSAP, 'hasScrollTrigger', hasScrollTrigger);
window.SmoothScroller = false;
window.easingScroll = function scroll(x) {
  return Math.min(1, 1.001 - Math.pow(2, -10 * x));
}
window.initSmoothScroll = function () {
  var superScroller = new Lenis({
    wrapper: window,
    content: document.documentElement,
    smoothWheel: true,
    smoothTouch: window.isDesktop,
    duration: 1.2,
    wheelMultiplier: 1,
    // smoothTouch: !this.appStore.isDesktop,
    // touchMultiplier: this.appStore.isDesktop ? 2 : 1,
    // lerp: this.appStore.isDesktop ? 0.1 : 1,
    // duration: this.appStore.isDesktop ? 1.2 : 0.8,
    easing: easingScroll
  });

  superScroller.on('scroll', function (_ref4) {
    var scroll = _ref4.scroll,
      limit = _ref4.limit,
      velocity = _ref4.velocity,
      direction = _ref4.direction,
      progress = _ref4.progress;
    if (hasScrollTrigger) {
      ScrollTrigger.update();
    }
  });
  function raf(time) {
    superScroller.raf(time)
    requestAnimationFrame(raf)
  }
  if (window.isDesktop) {
    var dspTimeout;
    document.documentElement.addEventListener('wheel', function(e, a, el) {
      if (!document.documentElement.classList.contains('lenis-wheeling')) document.documentElement.classList.add('lenis-wheeling');
      if (dspTimeout) clearTimeout(dspTimeout);
      dspTimeout = setTimeout(function () {
        document.documentElement.classList.remove('lenis-wheeling');
      }, 500);
    });
    // Raf
    if (hasGSAP) {
      gsap.ticker.add(function (time) {
        superScroller.raf(time * 1000);
      });
    } else{
      requestAnimationFrame(raf)
    }
    if (hasScrollTrigger) {
      ScrollTrigger.config({
        ignoreMobileResize: true
      });
      ScrollTrigger.clearScrollMemory();
      ScrollTrigger.scrollerProxy(document.documentElement, {
        scrollTop: function scrollTop(value) {
          return superScroller.scroll;
        },
        getBoundingClientRect: function getBoundingClientRect() {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight
          };
        }
      });
    }
  } else {
    // Raf
    if (hasGSAP) {
      gsap.ticker.add(function (time) {
        superScroller.raf(time * 1000);
      });
    } else {
      requestAnimationFrame(raf)
    }
    if (hasScrollTrigger) {
      ScrollTrigger.defaults({
        scroller: document.documentElement
      });
      ScrollTrigger.config({
        ignoreMobileResize: true,
        autoRefreshEvents: 'DOMContentLoaded,load'
      });
      ScrollTrigger.scrollerProxy(document.documentElement, {
        scrollTop: function scrollTop(value) {
          return superScroller.scroll;
        },
        getBoundingClientRect: function getBoundingClientRect() {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight
          };
        }
      });
    }
    // gsap.ticker.add((time) => { ScrollTrigger.update(); });
  }
  window.SmoothScroller = superScroller;
}

window.destroySmoothScroll = function () {
  if (window.SmoothScroller) window.SmoothScroller.destroy();
  window.SmoothScroller = false;
}

window.initSmoothScroll();